import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectChassisHeightManufacturerFilter,
  selectChassisHeightMasterModelFilter,
  selectChassisHeightSuspensionTypeFilter,
  selectChassisHeightYearFilter,
} from "../../redux/selector";
import { chassisHeightActions } from "../../redux/slice";
import {
  ChassisHeightFilterValue,
  ChassisHeightYearFilter,
} from "../../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const FILTER_OPTIONS: ChassisHeightFilterValue[] = ["ALL"];
const YEAR_OPTIONS: ChassisHeightYearFilter[] = ["ALL", "2016"];

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const manufacturerFilter = useSelector(selectChassisHeightManufacturerFilter);
  const suspensionTypeFilter = useSelector(
    selectChassisHeightSuspensionTypeFilter
  );
  const masterModelFilter = useSelector(selectChassisHeightMasterModelFilter);
  const yearFilter = useSelector(selectChassisHeightYearFilter);

  const getAllLabel = () => t("CHASSIS_HEIGHT.FILTERS.ALL");

  const getYearLabel = (value: ChassisHeightYearFilter) =>
    value === "ALL" ? getAllLabel() : value;

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("CHASSIS_HEIGHT.ACTIONS.ADD")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("CHASSIS_HEIGHT.FILTERS.YEAR.LABEL")}
          value={yearFilter}
          options={YEAR_OPTIONS}
          getOptionLabel={getYearLabel}
          onChange={(value) =>
            dispatch(chassisHeightActions.setYearFilter(value))
          }
        />
        <FilterSelect
          label={t("CHASSIS_HEIGHT.FILTERS.MASTER_MODEL.LABEL")}
          value={masterModelFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(chassisHeightActions.setMasterModelFilter(value))
          }
        />
        <FilterSelect
          label={t("CHASSIS_HEIGHT.FILTERS.SUSPENSION_TYPE.LABEL")}
          value={suspensionTypeFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(chassisHeightActions.setSuspensionTypeFilter(value))
          }
        />
        <FilterSelect
          label={t("CHASSIS_HEIGHT.FILTERS.MANUFACTURER.LABEL")}
          value={manufacturerFilter}
          options={FILTER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(chassisHeightActions.setManufacturerFilter(value))
          }
        />
      </div>
    </div>
  );
};

export default ActionBar;
